module.exports = __webpack_public_path__ + "img/icone_icone_3.510b41ec.svg";